import { ProseMirror } from '@progress/kendo-react-editor'

const styles = `
body {
  line-height: 1.15;
}

a {
  color: #1155cc;
}

a:any-link {
  text-decoration: underline;
}

.k-content p, .k-content ul {
  margin: 0;
}

/* sanitizeUnsafeContent が style 属性を丸ごと除去するため、基礎データ集の
   画像はサイズ調整を class 経由で行う（style="max-width" は使えない）。 */
.basic-output-image {
  max-width: 100%;
}
`

export const stylesheetPlugin = () =>
  new ProseMirror.Plugin({
    view: (view) => {
      const root = view.dom.getRootNode() as Document
      const head = root.head

      const style = root.createElement('style')
      style.appendChild(root.createTextNode(styles))
      head.appendChild(style)

      return {
        destroy: () => {
          head.removeChild(style)
        },
      }
    },
  })
